module.exports = require("./sv-SE.js");